/**
 * Penanda "pengumuman sudah ditutup pada sesi ini".
 *
 * Disimpan di sessionStorage, bukan di basis data: menutup pengumuman TIDAK
 * berarti selesai membacanya - pengumuman yang sama sengaja disodorkan lagi
 * pada login berikutnya. Yang perlu dicegah hanyalah munculnya berulang kali
 * setiap berpindah halaman dalam satu sesi.
 *
 * Penanda dibuang saat keluar, supaya masuk kembali memunculkannya lagi
 * meskipun tab peramban tidak pernah ditutup.
 */
export const KUNCI_PENGUMUMAN_DITUTUP = "pengumumanDitutup";

export function sudahDitutupSesiIni() {
  try {
    return sessionStorage.getItem(KUNCI_PENGUMUMAN_DITUTUP) === "1";
  } catch (galat) {
    return false;
  }
}

export function lupakanPenandaPengumuman() {
  try {
    sessionStorage.removeItem(KUNCI_PENGUMUMAN_DITUTUP);
  } catch (galat) {
    // Penyimpanan diblokir - tidak ada yang perlu dibersihkan.
  }
}
